export const EventInfoConstants = {
  presenters: 'Presented By:',
};
